import api from '../../api'

import {
    CREATE_NEW_APPRAISALFILE,
    SET_APPRAISALFILE,
    RESET_APPRAISALFILE,
    SET_APPRAISALFILE_DATE_CREATED,
    SET_APPRAISALFILE_DATE_MODIFIED,
    SET_APPRAISALFILE_DIRTYNESS,
    SET_APPRAISALFILE_ID,
    SET_APPRAISALFILE_PATH,
    UPDATE_APPRAISALFILE,
    SET_APPRAISALFILE_DESCRIPTION,
    SET_APPRAISALFILE_NUMBER
} from '../../constants'

const default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null
}
const state = default_state

const actions = {
    CREATE_NEW_APPRAISALFILE: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.get({path: 'stats/files/'})
                .then((res) => {
                    // console.log('create_new_apprisalfile api.get res:')
                    // console.log(res)
                    // const number = res.basenumber + data.size + 1

                    commit(RESET_APPRAISALFILE)
                    api.create({path: data.path})
                        .then((res) => {
                            commit(SET_APPRAISALFILE_NUMBER, data.number)
                            commit(SET_APPRAISALFILE_ID, res.key)
                            commit(SET_APPRAISALFILE_DATE_CREATED, res.date_created)
                            commit(SET_APPRAISALFILE_DATE_MODIFIED, res.date_modified)
                            commit(SET_APPRAISALFILE_PATH, res.path)
                            api.set_value({
                                value: res.key,
                                path: data.path + '/' + res.key + '/' + 'id',
                                save_timestamp: false
                            })
                            api.set_value({
                                value: data.number,
                                path: data.path + '/' + res.key + '/' + 'number',
                                save_timestamp: false
                            }).then(res => resolve(res))
                        })
                })

        })

    },
    DELETE_APPRAISALFILE: ({state, commit, rootState}, data) => {

        let appraisalfile_id = data.key

        console.log('path check: ' + data.path)
        api.delete({key: data.key, path: data.path})
            .then((res) => {
                commit(RESET_APPRAISALFILE)

            })
        // TODO:
        // al borrar expedient s'ha de borrar també:
        // els informes que conté, i per tant de la llista de appraisalreport de cadascun dels realestates on hi figuri
        // s'ha de treure de la llista de appraisalfiles de cadascun dels realestates a on hi figuri

        _.forEach(data.appraisalreports, (value, key) => {

            api.get({path: 'appraisalreports' + '/' + key})
                .then((res) => {
                    console.log('huhuhuhuhaaaaalklklkkl res: ')
                    console.log(res)

                    _.forEach(res.realestates, (value2, key2) => {

                        api.delete({path: 'realestates' + '/' + key2 + '/' + 'appraisalreports' + '/' + key})
                            .then((res) => {
                                api.delete({path: 'realestates' + '/' + key2 + '/' + 'appraisalfiles' + '/' + appraisalfile_id})
                                    .then((res) => {
                                        api.delete({path: 'appraisalreports' + '/' + key})
                                            .then((res) => {
                                            })
                                    })
                            })

                    })

                })

        })

    },
    RESET_APPRAISALFILE: ({state, commit, rootState}) => {
        commit(RESET_APPRAISALFILE)
    },
    SET_APPRAISALFILE: ({state, commit, rootState}, data) => {

        console.log('set_appraisalfile data:')
        console.log(data)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_APPRAISALFILE, res)
            })

    },
    SET_APPRAISALFILE_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_DATE_CREATED, data)
    },
    SET_APPRAISALFILE_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_DATE_MODIFIED, data)
    },
    SET_APPRAISALFILE_ID: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_ID, data)
    },
    SET_APPRAISALFILE_PATH: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_PATH, data)
    },
    UPDATE_APPRAISALFILE: ({state, commit, rootState}, data) => {
        api.update({object: data.object, path: data.path, save_timestamp: true})
            .then((res) => {
                commit(SET_APPRAISALFILE_DATE_MODIFIED, res.date_modified)
                commit(SET_APPRAISALFILE_DIRTYNESS, false)

            })
    },
    SET_APPRAISALFILE_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_DESCRIPTION, data)
    },
    SET_APPRAISALFILE_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_APPRAISALFILE_NUMBER, data)
    }
}

const mutations = {
    [RESET_APPRAISALFILE] (state) {
        state.date_created = null
        state.date_modified = null
        state.id = null
        state.path = null
        state.dirty = false
        state.description = null
        state.number = null
    },
    [SET_APPRAISALFILE] (state, data) {
        // console.log('mutations SET_APPRAISALFILE data: ')
        // console.log(data)
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.id = check_undefined(data.id)
        state.path = check_undefined(data.path)
        state.dirty = false
        state.description = check_undefined(data.description)
        state.number = check_undefined(data.number)
    },
    [SET_APPRAISALFILE_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_APPRAISALFILE_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_APPRAISALFILE_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_APPRAISALFILE_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_APPRAISALFILE_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_APPRAISALFILE_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_APPRAISALFILE_NUMBER] (state, data) {
        state.number = data
        state.dirty = true
    },
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    appraisalfile: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/appraisalfile/appraisalfile.js